import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../authentication/Auth.scss";
import "antd/dist/antd.css";
import logo from "../image/smartbuyerLogo.png";
import verifyLogo1 from "../image/verifyLogo1.png"; 
import ButtonField from "../../src/common/htmlComponents/ButtonField";

const PaymentSuccessfully = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className="Login-Form-Page">
            <div className="wrapper fadeInDown">
                <img
                    className="NavLogo"
                    src={logo}
                    width={"200px"}
                    height={"36px"}
                    alt="Smart Buyer Logo"
                ></img>
                <div className="formContent">

                    <div className="FormTitle">
                    <img
                            src={verifyLogo1}
                            alt="Verification Icon"
                            width="48"
                            height="48"
                        />
                        <h1>Payment Terms!</h1>
                        <span>YaaHoo! You Have Successfully Verified Your Payment</span>
                    </div>


                    <ButtonField
                        type="primary"
                        htmlType="submit"
                        className="GradiantBtn"
                        label={t("login")}
                        onClick={() => navigate("/")}
                    />



                </div>
            </div>
        </section>
    )
}

export default PaymentSuccessfully;